import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Clock, Map } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';
import { siteConfig } from '../../config/site';
import { trackEvent, FunnelSteps } from '../../lib/analytics';
import ambientacionImg from '../../assets/Ambientación ejemplo.png';
import examplePdf from '../../assets/Ambientación de ejemplo.pdf';

export function scrollToMap() {
  const el = document.getElementById(siteConfig.anchors.map);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function AmbHeroSection() {
  const handleCta = (e) => {
    e.preventDefault();
    trackEvent(FunnelSteps.CTA_CLICKED, { location: 'hero' });
    scrollToMap();
  };

  return (
    <section className="relative overflow-hidden bg-hero-gradient pt-24 pb-10 md:pt-28 md:pb-14">
      <div className="pointer-events-none absolute -right-32 top-20 h-96 w-96 rounded-full bg-brand-accent/10 blur-3xl" />

      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Badge className="bg-brand-accent/20 text-brand-accent">100 ha GRATIS</Badge>
          <h1 className="mt-4 font-display text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">
            Obtené un análisis de productividad gratuito para tu lote
          </h1>
          <p className="mt-4 text-lg text-white/75">
            Marcá tu lote y recibí en tu mail la ambientación en un PDF con zonas de productividad — listo
            para prescribir siembra y fertilización variable.
          </p>

          <div className="mt-6 flex flex-wrap gap-4 text-sm text-white/70">
            <span className="flex items-center gap-1.5">
              <Clock className="h-4 w-4 text-brand-accent" /> Entrega en minutos
            </span>
            <span className="flex items-center gap-1.5">
              <Map className="h-4 w-4 text-brand-accent" /> Hasta {siteConfig.freeHa} ha gratis
            </span>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button size="lg" onClick={handleCta} data-cta="hero-generate">
              Analizar ahora
              <ArrowDown className="h-5 w-5" />
            </Button>
            <Button
              href={examplePdf}
              variant="outline"
              size="lg"
              className="border-white/30 text-white hover:border-brand-accent hover:text-brand-accent"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="hero-pdf-example"
            >
              Ver PDF de ejemplo
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="relative"
        >
          <div className="rounded-2xl bg-gradient-to-br from-brand-accent/30 to-brand-dark/10 p-1 shadow-glow">
            <div className="overflow-hidden rounded-xl bg-white shadow-card">
              <div className="flex items-center justify-between border-b border-brand-dark/5 px-4 py-3">
                <span className="text-xs font-medium text-brand-earth">Vista previa de la ambientación</span>
                <span className="rounded-full bg-brand-accent/15 px-2 py-0.5 text-xs font-semibold text-brand-dark">
                  PDF
                </span>
              </div>
              <img
                src={ambientacionImg}
                alt="Ejemplo de mapa de ambientación"
                className="block w-full rounded-b-lg"
              />
            </div>
          </div>
          <div className="absolute -bottom-3 -left-3 rounded-xl bg-white px-3 py-2 text-xs font-semibold shadow-lg">
            <span className="text-brand-accent">●</span> 5 zonas de productividad
          </div>
        </motion.div>
      </div>
    </section>
  );
}
